import { render, staticRenderFns } from "./mobile-input.vue?vue&type=template&id=28cc156c&scoped=true&"
import script from "./mobile-input.vue?vue&type=script&lang=js&"
export * from "./mobile-input.vue?vue&type=script&lang=js&"
import style0 from "./mobile-input.vue?vue&type=style&index=0&id=28cc156c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc156c",
  null
  
)

export default component.exports